export const links = {
    brukerprofil: 'https://www.nav.no/person/personopplysninger',
    kontaktOss: 'https://www.nav.no/person/kontakt-oss/nb/tilbakemeldinger/feil-og-mangler',
    foreldrepenger: 'https://www.nav.no/foreldrepenger',
    foreldrepengesoknad: 'https://www.nav.no/foreldrepenger/soknad',
    foreldrepengerFarOgFar: 'https://www.nav.no/foreldrepenger#far-far',
    foreldrepengerOpptjening: 'https://www.nav.no/foreldrepenger#opptjening',
    nav: 'https://www.nav.no',
    papirsøknad: 'https://www.nav.no/soknader/nb/person/familie/foreldrepenger-og-engangsstonad',
    papirsøknadSvp: 'https://www.nav.no/start/soknad-svangerskapspenger?stegvalg=1',
    arbeidsforholdMineSider: 'https://www.nav.no/person/personopplysninger/nb/#arbeidsforhold',
    personvernerklæringOm: 'https://www.nav.no/personvernerklaering#om',
    plikter: 'https://www.nav.no/endringer',
    veiviser: 'https://www.nav.no/foreldrepenger/foreldrepenger-eller-engangsstonad/',
    engangsstonad: 'https://www.nav.no/engangsstonad',
    farMedmor: 'https://www.nav.no/engangsstonad#far_medmor',
    barn: 'https://www.nav.no/barn',
    foreldrepengerUtland: 'https://www.nav.no/foreldrepenger#utland',
    engangsstonadHvem: 'https://www.nav.no/engangsstonad#hvem',
    scanneDokument: 'https://www.nav.no/brukerstotte#bilde-vedlegg',
    svangerskapspengerUtland: 'https://www.nav.no/no/person/familie/relatert-informasjon/svangerskapspenger-og-utland',
    opphold: 'https://www.nav.no/foreldrepenger#opphold',
    hvorLenge: 'https://www.nav.no/foreldrepenger#hvor-lenge',
    hvorMye: 'https://www.nav.no/foreldrepenger/hvor-mye/',
    svangerskapspenger: 'https://www.nav.no/svangerskapspenger',
    tilretteleggingsskjema:
        'https://www.arbeidstilsynet.no/arbeidsmiljo/graviditet-og-arbeidsmiljo/skjema-for-tilrettelegging-for-gravide/',
    rettOgPlikt: 'https://www.nav.no/endringer',
    slikSøkerDuSvp: 'https://www.nav.no/barn',
    arbeidstilsynetSkjema:
        'https://www.arbeidstilsynet.no/arbeidsmiljo/graviditet-og-arbeidsmiljo/skjema-for-tilrettelegging-for-gravide/',
    frilanserInfoBoks:
        'https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/a-meldingen/veiledning/arbeidsforholdet/' +
        'type-arbeidsforhold/frilanser-oppdragstaker-og-personer-som-mottar-honorarer/',
    næringsdrivendeInfoBoks:
        'https://www.skatteetaten.no/bedrift-og-organisasjon/starte-og-drive/er-jeg-naringsdrivende/',
    selvstendigNæringsdrivendeHvorMye: 'https://www.nav.no/foreldrepenger#hvor-mye',
    hvordanSendeInntektsmelding:
        'https://www.nav.no/no/bedrift/tjenester-og-skjemaer/nav-og-altinn-tjenester/foreldrepenger-og-svangerskapspenger2',
    omLottOgHyre: 'https://www.skatteetaten.no/en/rettskilder/type/handboker/skatte-abc/2021/fiske/F-13.014/F-13.048/',
    fleksibeltuttak: 'https://www.nav.no/foreldrepenger#samtidig',
    farskapsportal: 'https://farskapsportal.nav.no/',
    barnehageloven: 'https://lovdata.no/nav/lov/2005-06-17-64/kapIV/%C2%A716',
    godkjentAktivitet: 'https://www.nav.no/foreldrepenger#hvor-lenge',
    søknadForeldrepenger: 'https://www.nav.no/start/soknad-foreldrepenger',
    søknadEngangsstønad: 'https://www.nav.no/start/soknad-engangsstonad',
    grunnbeløpet: 'https://www.nav.no/grunnbelopet',
    folketrygden:
        'https://www.nav.no/no/person/flere-tema/arbeid-og-opphold-i-norge/relatert-informasjon/medlemskap-i-folketrygden',
    omForeldrepenger: 'https://www.nav.no/foreldrepenger',
    utbetalingsoversikt: 'https://www.nav.no/utbetalingsoversikt/',
    foreldrepengerPlanlegger: 'https://www.nav.no/foreldrepenger/planlegger/',
    aktivitetskrav: 'https://www.nav.no/foreldrepenger#aktivitetskrav',
    saksbehandlingstider: 'https://www.nav.no/saksbehandlingstider',
    saksbehandlingstiderFp: 'https://www.nav.no/saksbehandlingstider#foreldrepenger',
    saksbehandlingstiderSvp: 'https://www.nav.no/saksbehandlingstider#svangerskapspenger',
    saksbehandlingstiderEs: 'https://www.nav.no/saksbehandlingstider#engangsstonad',
    klagerettigheter: 'https://www.nav.no/klage',
    klagerettigheterFp: 'https://www.nav.no/klage#foreldrepenger',
    klagerettigheterSvp: 'https://www.nav.no/klage#svangerskapspenger',
    klagerettigheterEs: 'https://www.nav.no/klage#engangsstonad',
    chatMedOss: 'https://www.nav.no/person/kontakt-oss/chat/familie',
    skrivTilOss: 'https://innboks.nav.no/s/skriv-til-oss?category=Familie',
    ringOss: 'tel:55553333',
    seFlereTlfNrOgTastevalg: 'https://www.nav.no/kontaktoss#ring-oss',
    meldFraOmEndringer: 'https://www.nav.no/foreldrepenger#melde',
    ventInntektsmelding: 'https://www.nav.no/arbeidsgiver/inntektsmelding',
    ventMeldekort:
        'https://www.nav.no/no/person/arbeid/dagpenger-ved-arbeidsloshet-og-permittering/meldekort-hvordan-gjor-du-det',
    søknadsfrister: 'https://www.nav.no/foreldrepenger#for-soknad',
};
